// extracted by mini-css-extract-plugin
module.exports = {"customNavlink":"styles_customNavlink__3pPFQ","activated":"styles_activated__2KW4G"};